import http, { expandURI } from '@/utils/ajax'
import { ACCOUNTS_INIT_LOADING, ACCOUNTS_INIT_SUCCESS, ACCOUNTS_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

export const init = {
  async accountsInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.accounts
    if (apiUrl) {
      commit(ACCOUNTS_INIT_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl))
        const menu = extractMenu(result.data._links)
        let commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(ACCOUNTS_INIT_SUCCESS, commitResult)
      } catch (error) {
        // console.log(error)
        commit(ACCOUNTS_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(ACCOUNTS_INIT_FAIL, 'The request failed because it is trying to execute an invalid API url.')
    }
  }
}
